import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { PopupRightComponent } from "./popup-right/popup-right.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HighlightModule } from "ngx-highlightjs";
import { PopUpLeftComponent } from "./pop-up-left/pop-up-left.component";
import { NumbersOnlyDirective } from "./directives/numbers-only.directive";
import { RouterModule } from "@angular/router";
import { PromoBannerPreviewComponent } from "./promo-banner-preview/promo-banner-preview.component";
import { MaterialModule } from 'mat-modules';
import { AppProductSupplierQuotesComponent } from '../views/pages/product/app-product-supplier-quotes/app-product-supplier-quotes.component';
import { ModalSupplierQuoteComponent } from '../views/pages/product/modal-supplier-quote/modal-supplier-quote.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
	declarations: [
		PopupRightComponent,
		PopUpLeftComponent,
		NumbersOnlyDirective,
		PromoBannerPreviewComponent,
		AppProductSupplierQuotesComponent,
		ModalSupplierQuoteComponent,
	],
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		HighlightModule,
		RouterModule,
		MaterialModule,
		TranslateModule,
	],
	providers: [],
	exports: [
		PopupRightComponent,
		PopUpLeftComponent,
		NumbersOnlyDirective,
		PromoBannerPreviewComponent,
		AppProductSupplierQuotesComponent,
		ModalSupplierQuoteComponent,
		TranslateModule,
	],
	entryComponents: [
		ModalSupplierQuoteComponent,
	],
})
export class SharedModule {}

